<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full" src="/img/brand/logo.svg" width="120" height="35" alt="Cashbac">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CB">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true id="togglertooltip"/>
      <b-tooltip target="togglertooltip" title="Hide Sidebar" placement="right"></b-tooltip>
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/welcome" exact>Getting Started</b-nav-item>
        <b-nav-item class="px-3" to="/foundations" exact>Foundations</b-nav-item>
        <b-nav-item class="px-3" to="/brand" exact>Brand Guidelines</b-nav-item>
        <b-nav-item class="px-3" to="/components" exact>Components</b-nav-item>
        <b-nav-item class="px-3" to="/dashboard" exact>Page Sample</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <DefaultHeaderDropdownAccnt/> -->
      </b-navbar-nav>
      <!--
      <AsideToggler class="d-none d-lg-block" />
      <AsideToggler class="d-lg-none" mobile />
      -->
    </AppHeader>
    <div class="app-body" >
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
          <span class="ml-1"> 2019 - 2020 &copy; </span>
          <a href="https://dae.ng" target="_blank" class="footer-link-black">Daeng Muhammad Feisal</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
